var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Card, CardActions, CardContent, CardMedia } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Path } from '../../api/types';
import Typography from '@mui/material/Typography';
import './wordCard.css';
import { DoneAll, PlayArrow, Spellcheck, StopCircleOutlined, WatchLater, } from '@mui/icons-material';
import { getUserWord, setUserWordsTextBook } from '../../common/functions';
var WordCard = function (_a) {
    var props = _a.props, color = _a.color, group = _a.group, change = _a.change;
    var _b = useState(false), clicked = _b[0], setClicked = _b[1];
    var _c = useState(false), userDifficultyWord = _c[0], setUserDifficultyWord = _c[1];
    var _d = useState(false), userLearnedWord = _d[0], setUserLearnedWord = _d[1];
    var htmlString = props.textExample;
    var playAudio = function (arr) {
        setTimeout(function () {
            arr[0].play();
            setTimeout(function () {
                arr[1].play();
                setTimeout(function () {
                    arr[2].play();
                }, arr[1].duration * 1000);
            }, arr[0].duration * 1000);
        });
    };
    var handlePlayIconClick = function () {
        var arr = [
            new Audio(Path.base + props.audio),
            new Audio(Path.base + props.audioMeaning),
            new Audio(Path.base + props.audioExample),
        ];
        setTimeout(function () {
            setClicked(true);
            playAudio(arr);
            setTimeout(function () { return setClicked(false); }, (arr[0].duration + arr[1].duration + arr[2].duration) * 1000);
        }, 500);
    };
    var handleSetHardWord = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getUserWord(props._id)];
                case 1:
                    (_a.sent())
                        ? setUserWordsTextBook(props._id, {
                            difficulty: 'hard',
                            optional: {
                                isKnown: false,
                                streak: props.userWord.optional.streak
                                    ? props.userWord.optional.streak
                                    : 0,
                                lastaudio: props.userWord.optional.lastaudio !== undefined
                                    ? props.userWord.optional.lastaudio
                                    : undefined,
                                lastsprint: props.userWord.optional.lastsprint !== undefined
                                    ? props.userWord.optional.lastsprint
                                    : undefined,
                            },
                        }, 'PUT')
                        : setUserWordsTextBook(props._id, {
                            difficulty: 'hard',
                            optional: { isKnown: false, streak: 0 },
                        });
                    setUserDifficultyWord(function (userDifficultyWord) {
                        return userDifficultyWord ? false : true;
                    });
                    change();
                    return [2 /*return*/];
            }
        });
    }); };
    var handleSetNormalWord = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            setUserWordsTextBook(props._id, {
                difficulty: 'easy',
                optional: {
                    isKnown: false,
                    streak: props.userWord.optional.streak,
                    lastaudio: props.userWord.optional.lastaudio,
                    lastsprint: props.userWord.optional.lastsprint,
                },
            }, 'PUT');
            setUserDifficultyWord(function (userDifficultyWord) {
                return userDifficultyWord ? false : true;
            });
            change();
            return [2 /*return*/];
        });
    }); };
    var handleSetLearnedWorld = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getUserWord(props._id)];
                case 1:
                    (_a.sent())
                        ? setUserWordsTextBook(props._id, {
                            difficulty: 'easy',
                            optional: {
                                isKnown: true,
                                streak: props.userWord.optional.streak
                                    ? props.userWord.optional.streak
                                    : 0,
                                lastaudio: props.userWord.optional.lastaudio !== undefined
                                    ? props.userWord.optional.lastaudio
                                    : undefined,
                                lastsprint: props.userWord.optional.lastsprint !== undefined
                                    ? props.userWord.optional.lastsprint
                                    : undefined,
                            },
                        }, 'PUT')
                        : setUserWordsTextBook(props._id, {
                            difficulty: 'easy',
                            optional: { isKnown: true, streak: 0 },
                        });
                    setUserLearnedWord(function (userLearnedWord) {
                        return userLearnedWord ? false : true;
                    });
                    change();
                    return [2 /*return*/];
            }
        });
    }); };
    var handleSetUnlearnedWorld = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            setUserWordsTextBook(props._id, {
                difficulty: 'easy',
                optional: {
                    isKnown: false,
                    streak: props.userWord.optional.streak,
                    lastaudio: props.userWord.optional.lastaudio,
                    lastsprint: props.userWord.optional.lastsprint,
                },
            }, 'PUT');
            setUserLearnedWord(function (userLearnedWord) {
                return userLearnedWord ? false : true;
            });
            change();
            return [2 /*return*/];
        });
    }); };
    useEffect(function () {
        var isUserDifficultyWord = function () {
            if (localStorage.userInfo && props.userWord) {
                props.userWord.difficulty === 'hard'
                    ? setUserDifficultyWord(true)
                    : null;
            }
        };
        var isUserLearnedWord = function () {
            if (localStorage.userInfo &&
                props.userWord &&
                props.userWord.optional &&
                group !== 7) {
                props.userWord.optional.isKnown ? setUserLearnedWord(true) : null;
            }
        };
        isUserDifficultyWord();
        isUserLearnedWord();
    }, []);
    return (React.createElement(Card, { sx: {
            boxSizing: 'border-box',
            maxWidth: '265px',
            m: 2,
            bgcolor: userLearnedWord
                ? 'gold'
                : userDifficultyWord
                    ? 'brown'
                    : color,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-start',
        } },
        React.createElement(CardMedia, { component: "img", height: "240", image: Path.base + props.image, alt: props.word }),
        React.createElement("div", { style: {
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                height: 'calc(100% - 240px)',
            } },
            React.createElement(CardContent, { sx: {
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                } },
                React.createElement(Typography, { color: "#black", variant: "h5" },
                    props.word,
                    " \u2014 ",
                    props.transcription),
                React.createElement(Typography, { gutterBottom: true, color: "gray" }, props.wordTranslate),
                React.createElement(Typography, { dangerouslySetInnerHTML: { __html: props.textMeaning }, color: "#black", sx: { alignSelf: 'stretch' } }),
                React.createElement(Typography, { gutterBottom: true, color: "gray", sx: { alignSelf: 'stretch' } }, props.textMeaningTranslate),
                React.createElement(Typography, { dangerouslySetInnerHTML: { __html: htmlString }, color: "#black", sx: { alignSelf: 'stretch' } }),
                React.createElement(Typography, { color: "gray", sx: { alignSelf: 'stretch' } }, props.textExampleTranslate),
                props.userWord &&
                    props.userWord.optional &&
                    props.userWord.optional.lastsprint === true ? (React.createElement(Typography, { component: 'span', color: "green", sx: { alignSelf: 'center', p: 1 } }, "\u0421\u043F\u0440\u0438\u043D\u0442: \u0443\u0433\u0430\u0434\u0430\u043D\u043E")) : props.userWord &&
                    props.userWord.optional &&
                    props.userWord.optional.lastsprint === false ? (React.createElement(Typography, { component: 'span', color: "red", sx: { alignSelf: 'center', p: 1 } }, "\u0421\u043F\u0440\u0438\u043D\u0442: \u043D\u0435 \u0443\u0433\u0430\u0434\u0430\u043D\u043E")) : localStorage.userInfo ? (React.createElement(Typography, { component: 'span', color: "gray", sx: { alignSelf: 'center', p: 1 } }, "\u0421\u043F\u0440\u0438\u043D\u0442: \u043D\u0435 \u043F\u043E\u043F\u0430\u0434\u0430\u043B\u043E\u0441\u044C")) : null,
                props.userWord &&
                    props.userWord.optional &&
                    props.userWord.optional.lastaudio === true ? (React.createElement(Typography, { component: 'span', color: "green", sx: { alignSelf: 'center', p: 1 } }, "\u0410\u0443\u0434\u0438\u043E\u0432\u044B\u0437\u043E\u0432: \u0443\u0433\u0430\u0434\u0430\u043D\u043E")) : props.userWord &&
                    props.userWord.optional &&
                    props.userWord.optional.lastaudio === false ? (React.createElement(Typography, { component: 'span', color: "red", sx: { alignSelf: 'center', p: 1 } }, "\u0410\u0443\u0434\u0438\u043E\u0432\u044B\u0437\u043E\u0432: \u043D\u0435 \u0443\u0433\u0430\u0434\u0430\u043D\u043E")) : localStorage.userInfo ? (React.createElement(Typography, { component: 'span', color: "gray", sx: { alignSelf: 'center', p: 1 } }, "\u0410\u0443\u0434\u0438\u043E\u0432\u044B\u0437\u043E\u0432: \u043D\u0435 \u043F\u043E\u043F\u0430\u0434\u0430\u043B\u043E\u0441\u044C")) : null),
            React.createElement(CardActions, { sx: { display: 'flex', justifyContent: 'space-around' } },
                clicked ? (React.createElement(StopCircleOutlined, null)) : (React.createElement(PlayArrow, { titleAccess: "\u0412\u043E\u0441\u043F\u0440\u043E\u0438\u0437\u0432\u0435\u0441\u0442\u0438", sx: { cursor: 'pointer' }, onClick: function () {
                        clicked ? null : handlePlayIconClick();
                    } })),
                localStorage.userInfo ? (React.createElement(React.Fragment, null,
                    userLearnedWord ? null : userDifficultyWord ? (React.createElement(DoneAll, { titleAccess: "\u0423\u0431\u0440\u0430\u0442\u044C \u0438\u0437 \u0441\u043B\u043E\u0436\u043D\u044B\u0445", sx: { cursor: 'pointer' }, onClick: function () {
                            handleSetNormalWord();
                        } })) : (React.createElement(WatchLater, { titleAccess: "\u0421\u0434\u0435\u043B\u0430\u0442\u044C \u0441\u043B\u043E\u0436\u043D\u044B\u043C", sx: { cursor: 'pointer' }, onClick: function () { return handleSetHardWord(); } })),
                    React.createElement(Spellcheck, { titleAccess: "\u0418\u0437\u0443\u0447\u0435\u043D\u043D\u043E\u0435", sx: { cursor: 'pointer' }, onClick: function () {
                            userLearnedWord
                                ? handleSetUnlearnedWorld()
                                : handleSetLearnedWorld();
                        } }))) : null))));
};
export default WordCard;
